import moment from 'moment'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { DatePicker, Input } from '.'
import InputType from '../constants/inputType'
import {
  hasValidationError,
  ruleNames,
  validationErrorTranslation,
} from '../validation'
import { TYPE_ERROR } from 'components/Toast'
import { openToast } from 'store/toast'
import { useDispatch } from 'react-redux'

interface PayoutTariffFormFieldsProps {
  validationErrors: any
  setFieldValues: any
  fieldValues: any
  isUpdateForm: boolean
  isInitialForm?: boolean
}

const MIN_DAYS_IN_THE_FUTURE_FOR_START_DATE = 1
const MAX_CONTRACT_FILE_SIZE = 2000000
const ACCEPTED_FILE_LIST = 'application/pdf, image/png, image/jpeg'

function PayoutTariffFormFields(props: PayoutTariffFormFieldsProps) {
  const {
    validationErrors,
    setFieldValues,
    fieldValues,
    isUpdateForm,
    isInitialForm,
  } = props
  const dispatch = useDispatch()

  const minStartDate = (date) => {
    return date.isBefore(
      moment().startOf('day').add(MIN_DAYS_IN_THE_FUTURE_FOR_START_DATE, 'days')
    )
  }

  const { t } = useTranslation()

  useEffect(() => {
    !isUpdateForm &&
      setFieldValues({
        startDate: moment()
          .startOf('day')
          .add(MIN_DAYS_IN_THE_FUTURE_FOR_START_DATE, 'days')
          .format('YYYY-MM-DD'),
      })
  }, [])

  return (
    <div>
      <div className="input-row mb__xl">
        <Input
          label={t('common:labels.payout_energyPrice')}
          mandatory
          value={fieldValues.energyPrice}
          onChange={(e: React.FormEvent<HTMLInputElement>) =>
            setFieldValues({ energyPrice: e.currentTarget.value })
          }
          hasValidationError={hasValidationError(
            ruleNames.payout.energyPrice,
            validationErrors
          )}
          validationErrorLabel={validationErrorTranslation(
            ruleNames.payout.energyPrice,
            validationErrors,
            t
          )}
          placeholder={t('common:placeholder.payout_energyPrice')}
          containerClass="input__container--6-el input__container--6-el-row"
          suffix={t('payout:energy_price_suffix')}
        />

        <div className="input__container input__container--6-el input__container--6-el-row">
          <div className={!isUpdateForm ? 'hidden' : ''}>
            <div
              style={{
                position: 'absolute',
                top: '34px',
                right: '50px',
                zIndex: '99',
              }}
            ></div>
            <div className={isInitialForm ? 'hidden' : ''}>
              <DatePicker
                id="startDate"
                value={fieldValues.startDate}
                disabled={!isUpdateForm}
                onChange={(selectedDate) =>
                  setFieldValues({
                    startDate: moment(selectedDate).isValid()
                      ? moment(selectedDate).format('YYYY-MM-DD')
                      : '',
                  })
                }
                hasValidationError={hasValidationError(
                  ruleNames.payout.startDate,
                  validationErrors
                )}
                validationErrorLabel={validationErrorTranslation(
                  ruleNames.payout.startDate,
                  validationErrors,
                  t
                )}
                label={t('common:labels.payout_startDate') + '*'}
                isOutsideRange={minStartDate}
                displayFormat={() => 'DD.MM.YYYY'}
                placeholder={t('common:placeholder.payout_startDate')}
                isWeekendAllowed={true}
              />
            </div>
          </div>
        </div>

        <Input
          id="payout_energyContract"
          label={t('common:labels.payout_energyContract', {
            maxFileSize: MAX_CONTRACT_FILE_SIZE / 1000000,
          })}
          mandatory
          accept={ACCEPTED_FILE_LIST}
          type={InputType.FILE}
          onChange={async (e: React.FormEvent<HTMLInputElement>) => {
            if (
              e.currentTarget &&
              e.currentTarget.files &&
              e.currentTarget.files.length === 1
            ) {
              const size = e.currentTarget.files[0].size
              if (size > MAX_CONTRACT_FILE_SIZE) {
                setFieldValues({
                  energyContract: {},
                })
                e.currentTarget.value = ''
                dispatch(
                  openToast(
                    TYPE_ERROR,
                    t('toast:contract_file_size_too_large', {
                      maxFileSize: MAX_CONTRACT_FILE_SIZE / 1000000,
                    })
                  )
                )
              } else {
                setFieldValues({
                  // energyContract: await prepareFile(e.currentTarget.files[0])
                  energyContract: e.currentTarget.files[0],
                })
              }
            }
          }}
          hasValidationError={hasValidationError(
            ruleNames.payout.energyContract,
            validationErrors
          )}
          validationErrorLabel={validationErrorTranslation(
            ruleNames.payout.energyContract,
            validationErrors,
            t
          )}
          placeholder={t('common:placeholder.payout_energyContract')}
          containerClass="input__container--6-el input__container--6-el-row"
        />
      </div>
    </div>
  )
}

export default PayoutTariffFormFields
